import { Injectable } from '@angular/core';
import { HttpService } from './http/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Sh6Service {

  constructor(private httpService: HttpService) { }

    sampleShRecord(object) {
        console.log("object", object);
        var request = {
            URL: "Sh6/shEntry",
            DATA: object
        }
        return this.httpService.post(request);
    }

    getRegisterDirector(object) {
        var registerList = {
            URL: "sh6/getSh6/5cee33d225242e023acfb2d4",
            DATA: object
        }
        return this.httpService.post(registerList);

    }

    removesh6details(_id) {
        var request = {
            URL: "sh6/deletadetails/" + _id
        }
        return this.httpService.get(request);
    }

    updatesh6(_id) {
        var editlist = {
            URL: "sh6/update/" + _id,
        }
        return this.httpService.get(editlist);
    }

    updateSh6(object, id) {
        var request = {
            URL: "sh6/updateSh6/" + id,
            DATA: object
        }
        return this.httpService.post(request);
    }

    generateSh6Document(object) {
        var request = {
            URL: "sh6/generateSh6Document",
            DATA: object
        }
        return this.httpService.post(request);
    }

    downloadSh6File(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "sh6/downloadDocument/" + id + "/" + type + "/" + token;
    }
    downloadSh6PdfFile(id, type) {
        var token = localStorage.getItem('token')
        window.location.href = environment.pssServerUrl + "sh6/downloadPdfDocument/" + id + "/" + type + "/" + token;
    }

}
